const handleInjectScript = ({
  elementToInject = "head",
  targetToInject = "script",
  props = {},
  comment = {}
}) => {
  const htmlElement = document[elementToInject];
  const script = document.createElement(targetToInject);

  // Inject the beginning comment
  if (comment && comment.start)
    htmlElement.appendChild(document.createComment(comment.start));

  // Apply each prop as a property on the script element
  for (const [key, value] of Object.entries(props)) {
    // TextContent needs to be set directly, not via property assignment,
    // or else some browsers may ignore it if type isn’t set properly
    if (key === "textContent") {
      script.textContent = value;
    } else {
      script[key] = value;
    }
  }
  htmlElement.appendChild(script);

  // Inject the ending comment
  if (comment && comment.end)
    htmlElement.appendChild(document.createComment(comment.end));
};

const handleRemoveScript = ({ idToRemove, elementToRemove = "head" }) => {
  // find the script want to remove
  const existingScript = document.getElementById(idToRemove);
  // removing it if found
  if (existingScript) document[elementToRemove].removeChild(existingScript);
};

const isNeededInjectScript = (scriptId) => !document.getElementById(scriptId);

export { handleInjectScript, handleRemoveScript, isNeededInjectScript };



// WEBPACK FOOTER //
// ./src/app/common/Hooks/useScriptInjector/helper.js